import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';

export async function mountBrowserRoot(container, application, loadMarketing = () => import('./pages/marketing/MarketingBrowserRoot')) {
  // Named build files can be requested directly. They are not marketing URLs;
  // handing such a URL back to the same document would reload it indefinitely.
  const marketingPath = /^\/$|^\/orderhub\/?$|^\/(features|blog|use-cases)(\/|$)/.test(window.location.pathname);
  if (marketingPath && container.dataset.plateosMarketing === 'true' && container.hasChildNodes()) {
    // Leave the useful HTML in place while its interaction code downloads.
    const { default: MarketingBrowserRoot } = await loadMarketing();
    return hydrateRoot(container, <React.StrictMode><MarketingBrowserRoot /></React.StrictMode>);
  }
  const root = createRoot(container);
  root.render(application);
  return root;
}
